import { z } from 'zod'

/** Login request body. Shared so the web form and the API validate identically. */
export const loginInputSchema = z
  .object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(1, 'Password is required'),
    /** Optional company to activate when the user has multiple memberships. */
    companyId: z.string().uuid().optional(),
  })
  .strict()

export type LoginInput = z.infer<typeof loginInputSchema>

export const switchCompanyInputSchema = z
  .object({
    companyId: z.string().uuid(),
  })
  .strict()

export type SwitchCompanyInput = z.infer<typeof switchCompanyInputSchema>

/** Request a password-reset email. The response never reveals whether the email has an account. */
export const forgotPasswordInputSchema = z
  .object({
    email: z.string().trim().toLowerCase().email(),
  })
  .strict()

export type ForgotPasswordInput = z.infer<typeof forgotPasswordInputSchema>

/** Complete a reset with the one-time token from the email. */
export const resetPasswordInputSchema = z
  .object({
    token: z.string().min(1, 'Reset link is missing its token'),
    password: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .max(200),
  })
  .strict()

export type ResetPasswordInput = z.infer<typeof resetPasswordInputSchema>
